import BannerAdditionalCheckInfo from '../BannerAdditionalCheckInfo';
import { ICertifications } from '@/lib/interface.ts';
import { Separator } from '@/components/ui';

type TProps = {
	certification: ICertifications;
};

const UserCertificationItemAdditionalCheckInfo = ({ certification }: TProps) => {

	if (!certification.additionalCheck) {
		return <></>;
	}

	return (
		<div className='flex flex-col max-w-[420px]'>
			<Separator />
			<BannerAdditionalCheckInfo
				additionalCheck={certification.additionalCheck}
				className='py-3' />
			<Separator />
		</div>
	);

};

export default UserCertificationItemAdditionalCheckInfo;
